import store from '../../store'
export default function auth({next, router}) {
    if (store.getters["user/isLoggedIn"]) {
        return router.push({name: "dashboard"});
    }
    return next();
}
